export { default as InputText } from './InputText';



// WEBPACK FOOTER //
// ./src/components/FormControls/InputText/index.ts